import { css, Theme, useTheme } from '@emotion/react'
import { FC } from 'react'

type Props = {
  value?: string
}

const ConfirmText: FC<Props> = ({ value }) => {
  const theme = useTheme()
  if (!value) return null

  return <p css={confirmStyle(theme)}>{value}</p>
}

export default ConfirmText

const confirmStyle = (theme: Theme) => css`
  color: ${theme.color.black};
  font-size: 20px;
  line-height: 1.7;
  word-break: break-all;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`
